import { george, observable, observer, React, ui } from "aaa";

const ChooseReleaseKeyComponent = observer((props: {
    store: ReleaseKeyStore,
}) => {
    const handleChange = (event: any, value: string) => {
        props.store.releaseKey = value;
        props.store.invalidKey = false;
    };

    return (
        <>
            <george.TextField
                id="releaseKey"
                onChange={handleChange}
                value={props.store.releaseKey}
                aria-label={ui.__("shop.prepaid.releaseKey")}
            />
            {props.store.invalidKey &&
                <p className="theme-validation-error">{ui.__("shop.prepaid.releaseKey.error")}</p>
            }
        </>
    );
});

export class ReleaseKeyStore {
    @observable releaseKey = "";
    @observable invalidKey = false;
}

export const ChooseReleaseKeyEmbedded = observer((props: {
    store: ReleaseKeyStore
}) => (
        <>
            <george.SectionTitle>
                {ui.__("shop.prepaid.releaseKey")}
            </george.SectionTitle>
            <george.SectionSubtitleTop>
                {ui.__("shop.prepaid.releaseKey.info")}
            </george.SectionSubtitleTop>
            <ChooseReleaseKeyComponent store={props.store} />
        </>
    )
);

export const ChooseReleaseKey = observer((props: {
    store: ReleaseKeyStore
}) => (
        <george.Card>
            <george.CardSectionTitle title={ui.__("shop.prepaid.releaseKey")} />
            <george.CardSectionContent>
                <george.SectionSubtitleTop>
                    {ui.__("shop.prepaid.releaseKey.info")}
                </george.SectionSubtitleTop>
                <ChooseReleaseKeyComponent store={props.store} />
            </george.CardSectionContent>
        </george.Card>
    )
);

export const ChooseReleaseKeyResponsive = observer((props: {
    store: ReleaseKeyStore
}) => (
        <>
            <george.SectionTitle>
                {ui.__("shop.prepaid.releaseKey")}
            </george.SectionTitle>
            <george.SectionSubtitleTop>
                {ui.__("shop.prepaid.releaseKey.info")}
            </george.SectionSubtitleTop>
            <george.ResponsiveFormElement label={ui.__("shop.prepaid.releaseKey")}>
                <ChooseReleaseKeyComponent store={props.store} />
            </george.ResponsiveFormElement>
        </>
    )
);



// WEBPACK FOOTER //
// ./src/components/common/ChooseReleaseKey.tsx